<div [ngClass]="isDesktop === true ? 'margin' : 'margin scroll-table'">
  <p-table
    #dt
    sortField="requestTypLab" sortMode="single"
    selectionMode="single"
    [columns]="listColumns"
    [value]="resultDisplay"
    [paginator]="false"
    responsiveLayout="stack"
    [breakpoint]="'960px'"
    rowGroupMode="subheader" groupRowsBy="requestTypLab"
    [lazy]=true
    (onRowSelect)="onRowSelect($event)"
    >
    <ng-template pTemplate="caption">
      <span class="header-grid-wrapper">
        <span class="align-right font-bold">{{'Last_Quer' | translate}}</span>
      </span>
    </ng-template>
    <ng-template let-columns pTemplate="header">
      <tr>
        @for (col of columns; track col; let i = $index) {
          <th
            [pSortableColumn]="col.field"
                    [ngClass]="{
                        'width-auto': col.field === 'label',
                        'width-col-date': col.field === 'dateaction'
                    }"
            >
            <p-sortIcon [field]="col.field"></p-sortIcon>
            <span>
              {{ col.header }}
            </span>
          </th>
        }
      </tr>
    </ng-template>
    <ng-template pTemplate="groupheader" let-rowData>
      <tr pRowGroupHeader>
        <td colspan="5">
          <span class="font-bold ml-2">{{rowData.requestTypLab}}</span>
        </td>
      </tr>
    </ng-template>
    <ng-template let-rowData let-rowIndex="rowIndex" let-columns="columns" pTemplate="body">
      <tr [pSelectableRow]="rowData" class="table-row">
        @for (col of columns; track col; let i = $index) {
          <td class="width-auto">
              @switch (col.field) {
                @case ('dateaction') {
                  {{ rowData[col.field] | datecompat | date: 'dd/MM/yyyy HH:mm:ss' }}
                }
                @default {
                  {{ rowData[col.field] }}
                }
              }
          </td>
        }
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td>{{'Empty_1' | translate}}</td>
      </tr>
    </ng-template>
  </p-table>
</div>